import { createSelector } from 'reselect'
import { AppGlobalState, Progress } from '../../types'
import { SeedClass } from 'modules/domain/seedClass/types'
import { EntityMetadata } from 'modules/domain/types'

const seedClassDicts = (state: AppGlobalState) => state.seedClass.items
const ids = (state: AppGlobalState) => state.seedClass.ids
const seedClass = (state: AppGlobalState, id: string): SeedClass | undefined => state.seedClass.items[id]
const meta = (state: AppGlobalState, id: string): EntityMetadata<SeedClass> =>
  state.seedClass.meta[id] || {
    fetchError: null,
    fetchProgress: Progress.IDLE,
    id,
    removeError: null,
    removeProgress: Progress.IDLE,
    updateError: null,
    updateProgress: Progress.IDLE,
  }
const itemFetchProgress = (state: AppGlobalState) => state.seedClass.itemFetchProgress
const listFetchProgress = (state: AppGlobalState) => state.seedClass.listFetchProgress
const listFetchNextProgress = (state: AppGlobalState) => state.seedClass.listFetchNextProgress
const listFetchNextError = (state: AppGlobalState) => state.seedClass.listFetchNextError
const listFetchError = (state: AppGlobalState) => state.seedClass.listFetchError
const seedClassList = createSelector(seedClassDicts, ids, listFetchProgress, (dict, ids, progress) => {
  if (progress === Progress.WORK) {
    return []
  }
  const result: SeedClass[] = []
  for (const id of ids) {
    result.push(dict[id])
  }
  return result
})

const filter = (state: AppGlobalState) => state.seedClass.filter
const sorting = (state: AppGlobalState) => state.seedClass.sorting
const page = (state: AppGlobalState) => state.seedClass.page
const total = (state: AppGlobalState) => state.seedClass.total
const updateProgress = (state: AppGlobalState) => state.seedClass.updateProgress
const removeProgress = (state: AppGlobalState) => state.seedClass.removeProgress
const addProgress = (state: AppGlobalState) => state.seedClass.addProgress
const addError = (state: AppGlobalState) => state.seedClass.addError
const hasNext = (state: AppGlobalState) => state.seedClass.total > state.seedClass.ids.length
const pageSize = (state: AppGlobalState) => state.seedClass.pageSize
const pages = (state: AppGlobalState) => Math.ceil(state.seedClass.total / state.seedClass.pageSize)

const SeedClassSelectors = {
  filter,
  sorting,
  page,
  total,
  updateProgress,
  removeProgress,
  addProgress,
  addError,
  seedClassDicts,
  ids,
  seedClass,
  meta,
  itemFetchProgress,
  listFetchProgress,
  listFetchError,
  seedClassList,
  hasNext,
  pageSize,
  listFetchNextProgress,
  listFetchNextError,
  pages,
}

export default SeedClassSelectors
